import PropTypes from 'prop-types';
import Component from '@ux/component';

export default class Overlay extends Component {
  render() { return super.render(); }
}

/**
 * Initial properties.
 *
 * @type {Object} default properties.
 * @public
 */
Overlay.defaultProps = {
  message: '',
  progress: false,
  show: true
};

/**
 * Allowed properties.
 *
 * @type {Object} properties.
 * @public
 */
Overlay.propTypes = {
  /** Contents of an overlay */
  children: PropTypes.node,
  /** The text, HTML or React component to render in the message overlay. Default is empty, meaning no content. */
  message: PropTypes.node,
  /** Boolean of whether the message overlay should be shown or hidden. Defaults to true. */
  show: PropTypes.bool,
  /** Whether or not to show the progress spinner with the text (appears before the text). Defaults to true */
  progress: PropTypes.bool,
  /** Styles to apply to the overlay wrapper */
  wrapperStyle: PropTypes.object
};
